import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useInViewReveal } from "@/hooks/useInViewReveal";

const tags = ["Pricing.Tag1", "Pricing.Tag2", "Pricing.Tag3"];

export const PricingSection = () => {
  const [t] = useTranslation("homeowners");
  const { ref: sectionRef, hasRevealed } = useInViewReveal({ threshold: 0.15 });

  return (
    <section
      id="pricing-savings"
      ref={sectionRef}
      className="w-full bg-[#f6f5f2] px-6 sm:px-12 lg:px-24 py-16 lg:py-32"
    >
      <div
        className={classNames(
          "relative flex flex-col lg:flex-row gap-10 lg:gap-0 items-center transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          {
            "opacity-100 translate-y-0": hasRevealed,
            "opacity-0 translate-y-[12px]": !hasRevealed,
          }
        )}
      >
        {/* Left card — overlapping on desktop */}
        <div className="relative z-10 bg-white border border-homeowners-border rounded-[48px] px-8 lg:px-16 xl:px-24 py-10 lg:py-16 flex flex-col items-center gap-8 lg:gap-12 text-[#1a1a1a] text-center lg:w-[42%] xl:w-[38%] flex-shrink-0">
          <p className="font-montserrat font-bold text-[clamp(0.875rem,0.7rem+0.6vw,1.75rem)] tracking-[0.07em]">
            {t("Pricing.CardLabel")}
          </p>
          <p className="font-playfair font-bold text-[clamp(1.5rem,1rem+2vw,3.5rem)] leading-tight">
            {t("Pricing.CardHeadline")}
          </p>
          <p className="font-montserrat font-normal text-[clamp(0.75rem,0.65rem+0.35vw,1rem)] leading-snug">
            {t("Pricing.CardFooter")}
          </p>
        </div>

        {/* Right area — Pricing Transparency */}
        <div className="bg-[#efefef] rounded-[48px] lg:rounded-l-none lg:rounded-r-[48px] px-8 lg:pl-16 xl:pl-40 lg:pr-16 xl:pr-24 py-14 lg:py-20 flex flex-col gap-8 lg:gap-14 justify-center flex-1">
          <div className="flex flex-col gap-6 lg:gap-8">
            <h3 className="font-minion text-homeowners-headline leading-none text-[clamp(1.5rem,0.8rem+3vw,4.75rem)]">
              {t("Pricing.Title")}
            </h3>
            <p className="font-montserrat font-normal text-[#1a1a1a] leading-snug text-[clamp(0.875rem,0.7rem+0.6vw,1.5rem)]">
              {t("Pricing.DescStart")}
              <span className="font-bold">{t("Pricing.DescBold")}</span>
              {t("Pricing.DescEnd")}
            </p>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-4 lg:gap-6">
            {tags.map((tagKey) => (
              <div
                key={tagKey}
                className="flex-1 min-w-[160px] h-10 lg:h-12 flex items-center justify-center overflow-hidden bg-[#848e9b] text-white font-montserrat text-[clamp(0.6rem,0.4rem+0.5vw,1.25rem)] px-4 xl:px-10 rounded-xl whitespace-nowrap"
              >
                {t(tagKey)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
